import Card from "components/card";
import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { transformTwoMongoAggregatesToApexLineChart } from "../../utils/analytics";

export default function CombinedLineProspects(props: {
    contacted: any[];
    responses: any[];
    period?: string;
    onPeriodChange?: (p: string) => void;
}) {
    const { contacted, responses, period = "weekly", onPeriodChange } = props;
    const [state, setState] = useState<any>(null);
    const [localPeriod, setLocalPeriod] = useState(period);

    useEffect(() => {
        setLocalPeriod(period);
    }, [period]);

    useEffect(() => {
        setState(
            transformTwoMongoAggregatesToApexLineChart(
                contacted || [],
                responses || [],
                localPeriod,
                false,
            ),
        );
    }, [contacted, responses, localPeriod]);

    const handlePeriodChange = (p: string) => {
        setLocalPeriod(p);
        if (onPeriodChange) onPeriodChange(p);
    };

    return (
        <Card extra={"relative p-3 text-sm lg:h-full max-h-[380px] border"}>
            <h4 className="ml-px text-sm font-medium text-gray-600">
                Contacted vs responses
            </h4>

            <div className="absolute right-4 top-4">
                <div className="flex mt-2 gap-4">
                    <p
                        className={`text-sm ${localPeriod === "weekly" ? "text-duckflow-500 underline" : ""} cursor-pointer`}
                        onClick={() => handlePeriodChange("weekly")}
                    >
                        Weekly
                    </p>
                    <p
                        className={`text-sm ${localPeriod === "monthly" ? "text-duckflow-500 underline" : ""} cursor-pointer`}
                        onClick={() => handlePeriodChange("monthly")}
                    >
                        Monthly
                    </p>
                    <p
                        className={`text-sm ${localPeriod === "quarterly" ? "text-duckflow-500 underline" : ""} cursor-pointer`}
                        onClick={() => handlePeriodChange("quarterly")}
                    >
                        Quarterly
                    </p>
                </div>
            </div>

            <div className="mt-2 h-[300px]">
                {state ? (
                    <ReactApexChart
                        options={state.options}
                        series={state.series}
                        type={"area"}
                        height={300}
                    />
                ) : (
                    <div className="flex justify-center items-center h-full">
                        <p className="text-gray-500">Chargement...</p>
                    </div>
                )}
            </div>
        </Card>
    );
}
